import React, {Component} from 'react';

class File extends Component {

    onChange = (event) => {
        const {
            params,
        } = this.props;

        const multiple = Boolean(params.multiple);

        if (multiple) {
            if (event.target.files.length) {
                this.props.setField(
                    params.name,
                    event.target.files,
                );
            }

            return;
        }

        if (event.target.files[0]) {
            this.props.setField(
                params.name,
                event.target.files[0],
            );
        }
    };

    render() {
        const {
            params,
            state,
        } = this.props;

        const field = state.fields[params.name];

        const hasError = field.error
            ? 'has-error'
            : '';

        return (
            <div
                className={
                    `field field-text ${params.id} ${hasError}`
                }
                style={params.style}
            >
                <div>
                    {params.label ? (
                        <label
                            htmlFor={params.id}
                            className={params.classLabel}
                        >
                            {params.label}
                        </label>
                    ) : null}

                    <input
                        type="file"
                        spellCheck="false"
                        autoComplete="off"
                        id={params.id}
                        className={params.classInput}
                        name={params.name}
                        onChange={this.onChange}
                        disabled={params.disabled}
                        multiple={Boolean(params.multiple)}
                    />

                    <p className="help-block help-block-error">
                        {field.error ? (
                            <span className="error">
                                <i className="fa fa-warning" />
                                {' '}
                                {field.error}
                            </span>
                        ) : null}
                    </p>
                </div>
            </div>
        );
    }
}

export default File;


// WEBPACK FOOTER //
// ./src/components/common/fields/File.js